import Vue from 'vue'
let cursorPlace = 0
let isComposing = false

const getCursorPlace = (event) => {
  const target = event.target
  cursorPlace = target.selectionStart || 0
}

const thousandthPlaceToNumber = (value) => {
  if (typeof value !== 'string') return
  return Number(value ? value.replace(/,/g, '') : '0')
}

const updateInputValue = (inputElement, needSetCursor = false, inputType = 'insertText') => {
  const value = inputElement.value
  let newValue = value
  if (value !== '' && value !== '-') {
    const numberAmount = thousandthPlaceToNumber(value)
    newValue = isNaN(numberAmount) ? '0' : numberAmount.toLocaleString()
  }
  if (needSetCursor) {
    cursorPlace = inputElement.selectionStart || 0
    if (value.length > newValue.length) cursorPlace -= 1
    else if (inputType !== 'deleteContentForward' && value.length < newValue.length) cursorPlace += 1
  }
  inputElement.value = newValue
  if (needSetCursor) inputElement.setSelectionRange(cursorPlace, cursorPlace)
  const event = new Event('input', { bubbles: false })
  inputElement.dispatchEvent(event)
  if (needSetCursor) inputElement.setSelectionRange(cursorPlace, cursorPlace)
}

const updateErrorInputValue = (inputElement, inputData) => {
  const value = inputElement.value
  const newValue =
    inputData.length === 1
      // 從最後一個開始替換，例如原本為 -123 輸入變成 -12-3 應該變為 -123
      ? value.split('').reverse().join('').replace(inputData, '').split('').reverse().join('')
      // 如果一次輸入兩個字，視為複製貼上的行為，則不 reverse 替換
      : value.replace(inputData, '')
  cursorPlace = inputElement.selectionStart || 0
  if (value.length < newValue.length) cursorPlace += 1
  else if (value.length > newValue.length) cursorPlace -= 1
  inputElement.value = newValue
  const event = new Event('input', { bubbles: false })
  inputElement.dispatchEvent(event)
  inputElement.setSelectionRange(cursorPlace, cursorPlace)
}

const handleInput = (event) => {
  const numberInputReg = /^(-?(\d,?)+)$|^-$/
  if ((!event.inputType && event.type !== 'compositionend') || isComposing) return
  if (event.data && !numberInputReg.test(event.target.value)) updateErrorInputValue(event.target, event.data)
  else updateInputValue(event.target, true, event.inputType)
}

const handleCompositionStart = () => {
  isComposing = true // 開始輸入全型文字時
}

const handleCompositionEnd = (event) => {
  isComposing = false // 輸入全型文字完成時
  handleInput(event)
}

export const thousandthInput = (app) => {
  app.directive('thousandth', {
    bind (el) {
      Vue.nextTick(() => {
        const inputElement = el.querySelector('input')
        if (inputElement) {
          inputElement.addEventListener('selectionchange', getCursorPlace)
          inputElement.addEventListener('input', handleInput)
          inputElement.addEventListener('compositionstart', handleCompositionStart)
          inputElement.addEventListener('compositionend', handleCompositionEnd)
          updateInputValue(inputElement)
        }
      })
    },
    unbind (el, binding) {
      const inputElement = el.querySelector('input')
      if (inputElement) {
        inputElement.removeEventListener('selectionchange', getCursorPlace)
        inputElement.removeEventListener('input', handleInput)
        inputElement.removeEventListener('compositionstart', handleCompositionStart)
        inputElement.removeEventListener('compositionend', handleCompositionEnd)
      }
    }
  })
}
